import { httpInterceptor } from '../http-interceptor';

export class AuxiliaryEquipmentService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getAllAuxiliaryEquipmentsNew',
    SAVE_NEW: 'Machine/saveNewAuxiliaryEquipment',
    UPDATE: 'Machine/saveNewAuxiliaryEquipment',
    DELETE: 'Machine/deleteAuxiliaryEquipment',
    SAVE_MAINTENANCE: 'Machine/SaveOrUpdateAuxiliaryEquipmentMaintenance',
    UPLOAD_DOCUMENT: 'Customer/Upload',
    GET_MAINTENANCE_RECORDS: 'Machine/getAllMaintenanceRecordsByAuxiliaryEquipmentId',
    GET_MAINTENANCE_RECORD_DETAILS: 'Machine/getAuxiliaryEquipmentMaintenanceRecordDetails',
    ADD_MAINTENANCE_RECORD: 'Machine/saveAuxiliaryEquipmentMaintenanceAllRecords',
    GET_BY_ASSET_NUMBER: 'Machine/getAllAuxiliaryByAsstNo',
    GET_SAFETY_CHECKLIST_BY_AUXILIARY_EQUIPMENT: 'Machine/auxiliaryEquipmentSafetyChecklistByAuxiliaryEquipment',
    SAVE_SAFETY_CHECKLIST: 'Machine/saveOrUpdateAuxiliaryEquipmentSafetyChecklist',
    DELETE_SAFETY_CHECKLIST: 'Machine/deleteAuxiliaryEquipmentSafetyChecklist'
  };

  static async getAllAuxiliaryEquipments(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async saveNewAuxiliaryEquipment(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_NEW, data);
  }

  static async updateAuxiliaryEquipment(data) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE, data);
  }

  static async deleteAuxiliaryEquipment(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async saveAuxiliaryEquipmentMaintenance(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MAINTENANCE, data);
  }

  static async uploadDocument(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, data);
  }

  static async getMaintenanceRecordsByAuxiliaryEquipmentId(auxiliaryEquipmentId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORDS}/${auxiliaryEquipmentId}`);
  }

  static async getMaintenanceRecordDetails(recordId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORD_DETAILS}/${recordId}`);
  }

  static async addMaintenanceRecord(data) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_MAINTENANCE_RECORD, data);
  }

  static async getAllAuxiliaryByAssetNumber(assetNumber) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ASSET_NUMBER}/${assetNumber}`);
  }

  static async getAuxiliaryEquipmentSafetyChecklistByAuxiliaryEquipment(auxiliaryEquipmentId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_SAFETY_CHECKLIST_BY_AUXILIARY_EQUIPMENT}/${auxiliaryEquipmentId}`,
    );
  }

  static async createAuxiliaryEquipmentSafetyChecklist(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_SAFETY_CHECKLIST, data);
  }

  static async deleteAuxiliaryEquipmentSafetyChecklist(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_SAFETY_CHECKLIST}/${id}`);
  }
}
